import {
  PERMISSION_ACCESS_KEYS,
  PERMISSION_RESOURCE_CODES,
} from '../src/permissions/definitions';

/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @param path  path 只支持两种占位符配置，第一种是动态参数 :id 的形式，第二种是 * 通配符，通配符只能出现路由字符串的最后。
 * @param component 配置 location 和 path 匹配后用于渲染的 React 组件路径。可以是绝对路径，也可以是相对路径，如果是相对路径，会从 src/pages 开始找起。
 * @param routes 配置子路由，通常在需要为多个路径增加 layout 组件时使用。
 * @param redirect 配置路由跳转
 * @param wrappers 配置路由组件的包装组件，通过包装组件可以为当前的路由组件组合进更多的功能。 比如，可以用于路由级别的权限校验
 * @param name 配置路由的标题，默认读取国际化文件 menu.ts 中 menu.xxxx 的值，如配置 name 为 login，则读取 menu.ts 中 menu.login 的取值作为标题
 * @param icon 配置路由的图标，取值参考 https://ant.design/components/icon-cn， 注意去除风格后缀和大小写，如想要配置图标为 <StepBackwardOutlined /> 则取值应为 stepBackward 或 StepBackward，如想要配置图标为 <UserOutlined /> 则取值应为 user 或者 User
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: '/callback',
    layout: false,
    component: './callback',
  },
  {
    path: '/user',
    layout: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './user/login',
      },
      {
        name: 'accessDenied',
        path: '/user/access-denied',
        component: './user/access-denied',
      },
    ],
  },
  {
    path: '/home',
    name: 'home',
    icon: 'home',
    access: PERMISSION_RESOURCE_CODES.home,
    component: './Home',
  },
  {
    path: '/contracts',
    name: 'contracts',
    icon: 'fileText',
    routes: [
      { path: '/contracts', redirect: '/contracts/mine' },
      {
        path: '/contracts/mine',
        name: 'mine',
        icon: 'user',
        access: PERMISSION_RESOURCE_CODES.contractsMine,
        component: './contracts/list',
      },
      {
        path: '/contracts/all',
        name: 'all',
        icon: 'appstore',
        access: PERMISSION_RESOURCE_CODES.contractsAll,
        component: './contracts/list',
      },
    ],
  },
  {
    path: '/contracts/new',
    name: 'contractCreate',
    hideInMenu: true,
    access: PERMISSION_ACCESS_KEYS.createContract,
    component: './contracts/create',
  },
  {
    path: '/contracts/:uuid/edit',
    name: 'contractEdit',
    hideInMenu: true,
    access: PERMISSION_RESOURCE_CODES.contractDetail,
    component: './contracts/detail',
  },
  {
    path: '/contracts/:uuid',
    name: 'contractDetail',
    hideInMenu: true,
    access: PERMISSION_RESOURCE_CODES.contractDetail,
    component: './contracts/detail',
  },
  {
    path: '/contract-approval',
    name: 'contractApproval',
    icon: 'audit',
    access: PERMISSION_RESOURCE_CODES.contractApproval,
    component: './contracts/approval',
  },
  {
    path: '/reviews',
    name: 'reviews',
    icon: 'safetyCertificate',
    component: './reviews',
  },
  {
    path: '/signing-parties',
    name: 'signingParties',
    icon: 'team',
    access: PERMISSION_RESOURCE_CODES.signingParties,
    component: './signing-parties',
  },
  {
    path: '/analytics',
    name: 'analytics',
    icon: 'barChart',
    routes: [
      { path: '/analytics', redirect: '/analytics/overview' },
      {
        path: '/analytics/overview',
        name: 'overview',
        icon: 'dashboard',
        access: PERMISSION_RESOURCE_CODES.analyticsOverview,
        component: './analytics/overview',
      },
      {
        path: '/analytics/contracts',
        name: 'contractAnalysis',
        icon: 'pieChart',
        access: PERMISSION_RESOURCE_CODES.analyticsContractAnalysis,
        component: './analytics/contract-analysis',
      },
      {
        path: '/analytics/performance',
        name: 'performance',
        icon: 'lineChart',
        access: PERMISSION_RESOURCE_CODES.analyticsPerformance,
        component: './analytics/performance',
      },
      {
        path: '/analytics/settlement',
        name: 'settlement',
        icon: 'transaction',
        access: PERMISSION_RESOURCE_CODES.analyticsOverview,
        component: './analytics/settlement',
      },
    ],
  },
  {
    path: '/settings',
    name: 'settings',
    icon: 'setting',
    routes: [
      {
        path: '/settings',
        redirect: '/settings/permissions',
      },
      {
        path: '/settings/permissions',
        name: 'permissions',
        icon: 'safetyCertificate',
        access: PERMISSION_ACCESS_KEYS.permissionManagement,
        component: './Permissions',
      },
      {
        path: '/settings/contract-types',
        name: 'contractTypes',
        icon: 'profile',
        access: PERMISSION_RESOURCE_CODES.contractTypes,
        component: './contract-types',
      },
      {
        path: '/settings/number-rules',
        name: 'numberRules',
        icon: 'sliders',
        access: PERMISSION_RESOURCE_CODES.numberRules,
        component: './number-rules',
      },
      {
        path: '/settings/ai-models',
        name: 'aiModels',
        icon: 'robot',
        access: 'tenantAdmin',
        component: './settings/ai-models',
      },
    ],
  },
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
];
